// extracted by mini-css-extract-plugin
module.exports = {"recent-button":"RecentButton_recent-button__NdF9E","recent-button-text":"RecentButton_recent-button-text__Cu7ep"};